export default __webpack_public_path__ + "static/media/excel-logo.51f2d943.svg";